import type { ArticleItem } from "@/types/content";

export const articles: ArticleItem[] = [
  {
    id: "1",
    title: "挠痒为什么让人又笑又躲？一篇轻松的趣味科普",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20illustration%20of%20a%20smiling%20person%20pulling%20their%20feet%20away%20playfully%20with%20tiny%20feathers%20floating%20around%2C%20cream%20and%20honey%20yellow%20background%2C%20soft%20grain%20texture%2C%20flat%20modern%20illustration&width=800&height=500&seq=article-cover-01&orientation=landscape",
    excerpt:
      "被挠的时候会笑，也会本能地躲开，这两种反应看起来矛盾，其实各有各的道理。这篇用最轻松的方式聊聊身体里那点小机关。",
    author: "内容编辑 小满",
    date: "2026-10-15",
    tag: "趣味科普",
    tags: ["科普", "轻松", "触觉"],
    views: 18600,
    heat: 95,
    readMinutes: 6,
    content: [
      {
        type: "p",
        text: "很多人都有过这样的瞬间：脚心被人轻轻一碰，先是忍不住笑出声，下一秒整个人已经缩成一团。明明在笑，身体却在拼命躲——这大概是挠痒最有趣的地方。",
      },
      {
        type: "h2",
        text: "笑，不等于觉得好玩",
      },
      {
        type: "p",
        text: "在研究中，被挠时产生的笑往往被归为一种反射性的反应，而不是对笑话那种「想明白了所以好笑」。它更接近身体对意外触碰的自动回应，所以哪怕你一点也不觉得开心，也可能控制不住地笑。",
      },
      {
        type: "p",
        text: "而躲开，则是另一套系统在工作。脚心、腋下、腰侧这些地方神经末梢密集，对轻微触碰格外敏感，身体会自动把它们当成需要留意的信号。笑与躲同时出现，其实是两套机制在同一个瞬间各干各的。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20a%20foot%20resting%20on%20a%20cream%20cushion%20with%20delicate%20line%20art%20showing%20touch%20sensation%20as%20gentle%20ripples%2C%20warm%20beige%20and%20golden%20palette%2C%20minimal%20educational%20illustration%20style&width=900&height=500&seq=article-inline-01&orientation=landscape",
        caption: "脚心对轻触格外敏感，这是身体的一种保护机制。",
      },
      {
        type: "h2",
        text: "为什么自己挠自己不觉得痒",
      },
      {
        type: "p",
        text: "因为大脑会提前预判自己的动作。当动作来自自己，身体知道接下来会发生什么，那份「意外感」就被抵消掉了。所以挠痒这件事，几乎注定要是两个人之间的互动才成立。",
      },
      {
        type: "quote",
        text: "痒的乐趣不在于刺激本身，而在于那份「猜不到下一步」的意外。",
      },
      {
        type: "p",
        text: "理解了这一点，也就明白为什么需要事先沟通。对有些人来说这只是玩笑，对另一些人却可能带来明显的不适。任何时候，一句「可以吗」都比任何技巧重要。",
      },
    ],
  },
  {
    id: "2",
    title: "羽毛、棉签还是手指？五种轻挠道具体验笔记",
    cover:
      "https://readdy.ai/api/search-image?query=Fresh%20flat%20lay%20illustration%20of%20feathers%2C%20cotton%20swabs%2C%20a%20soft%20brush%20and%20a%20linen%20cloth%20on%20a%20cream%20surface%2C%20warm%20natural%20light%2C%20clean%20minimal%20editorial%20composition%2C%20honey%20and%20terracotta%20accents&width=800&height=500&seq=article-cover-02&orientation=landscape",
    excerpt:
      "同样是轻挠，换一个道具，感受可以差得非常远。我们把常见道具挨个试了一遍，把差别整理成了这份轻松的笔记。",
    author: "道具实验室",
    date: "2026-10-11",
    tag: "体验笔记",
    tags: ["道具", "笔记", "测评"],
    views: 15400,
    heat: 90,
    readMinutes: 7,
    content: [
      {
        type: "p",
        text: "道具这件事，比想象中讲究。羽毛看起来最经典，实际体验下来却未必是所有人的第一选择。我们按「刺激强度」和「可控程度」两个维度，简单聊一聊五种常见道具。",
      },
      { type: "h2", text: "一、白色羽毛：经典但难控制" },
      {
        type: "p",
        text: "羽毛的触感最轻，几乎像风扫过，但它的方向很难控制，稍不留神就会滑到意想不到的位置。适合慢慢来，也适合第一次尝试的人，因为它足够温和。",
      },
      { type: "h2", text: "二、棉签：精准的小范围" },
      {
        type: "p",
        text: "棉签的优势是精准。你可以只碰一个小点，也可以沿着一条线慢慢移动。缺点是范围小，需要耐心，节奏太慢的时候反而会让人紧张。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Close%20up%20warm%20illustration%20of%20a%20hand%20holding%20a%20single%20white%20feather%20above%20a%20soft%20cream%20fabric%20with%20golden%20sunlight%2C%20minimal%20calm%20composition%2C%20beige%20and%20butter%20yellow%20palette%2C%20flat%20editorial%20style&width=900&height=500&seq=article-inline-02&orientation=landscape",
        caption: "越轻的触感，越需要放慢节奏。",
      },
      { type: "h2", text: "三、软毛刷：均匀且直接" },
      {
        type: "p",
        text: "软毛刷的接触面积大，感受更均匀，也更容易让人迅速进入状态。它适合作为暖场道具，但如果一开始就用，可能会有点突然。",
      },
      { type: "h2", text: "四、手指：最有互动感" },
      {
        type: "p",
        text: "手指的温度和力度都最自然，也最能根据对方的反应随时调整。缺点是难以保持完全一致的力度，不过对很多人来说，这恰好是它有意思的地方。",
      },
      { type: "h2", text: "五、丝巾：柔和的替代方案" },
      {
        type: "p",
        text: "丝巾介于羽毛和毛刷之间，触感柔滑，速度可控。它非常适合作为新手的第一件道具，也容易让人放松下来。",
      },
      {
        type: "quote",
        text: "没有最好的道具，只有最合适的节奏。慢一点，永远比用力一点更有效。",
      },
      {
        type: "p",
        text: "最后提醒一句：所有体验都请在双方明确同意、随时可以停止的前提下进行。道具只是道具，沟通才是关键。",
      },
    ],
  },
  {
    id: "3",
    title: "和好友玩挠痒游戏前，先说好这三条边界",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20friendly%20illustration%20of%20two%20friends%20sitting%20cross%20legged%20on%20a%20cream%20rug%20talking%20calmly%20with%20tea%20cups%2C%20soft%20afternoon%20light%2C%20minimal%20flat%20illustration%20in%20beige%20and%20honey%20tones&width=800&height=500&seq=article-cover-03&orientation=landscape",
    excerpt:
      "任何互动游戏，玩得开心的前提都是安全感。这三条简单的约定，能让一场轻松的游戏变得更舒服，也更尽兴。",
    author: "社区管理员 阿栗",
    date: "2026-10-08",
    tag: "社区公约",
    tags: ["安全", "沟通", "社区"],
    views: 12900,
    heat: 87,
    readMinutes: 5,
    content: [
      {
        type: "p",
        text: "社区里经常有人问：第一次和好友玩这类互动游戏，有什么需要注意的？其实答案很简单，把话说在前面就好。下面这三条，是我们最推荐的开场白。",
      },
      { type: "h2", text: "第一条：先说清楚「可以」和「不可以」" },
      {
        type: "p",
        text: "哪里可以碰、哪里绝对不行、最多能玩多久，这些问题在开始前用一分钟说清楚，比玩到一半喊停要轻松得多。明确的边界不是扫兴，而是让人敢于放松。",
      },
      { type: "h2", text: "第二条：约定一个「立刻停止」的信号" },
      {
        type: "p",
        text: "笑声会掩盖很多情绪，所以需要一个不会被误会的信号，比如举手、说一个特定的词、或者拍一下桌面。只要出现这个信号，无论进行到哪一步都立刻停下。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Calm%20illustration%20of%20a%20small%20wooden%20timer%20and%20two%20tea%20cups%20on%20a%20cream%20table%20beside%20a%20folded%20blanket%2C%20warm%20morning%20light%2C%20minimal%20editorial%20flat%20style%20with%20honey%20tones&width=900&height=500&seq=article-inline-03&orientation=landscape",
        caption: "提前约定时长和停止信号，是让双方都安心的方式。",
      },
      { type: "h2", text: "第三条：不勉强，也不追问" },
      {
        type: "p",
        text: "如果对方中途不想继续，那就结束，不需要理由，也不用解释。同样地，如果对方不想分享感受，也不要追问。舒服的互动，从来不是靠劝出来的。",
      },
      {
        type: "quote",
        text: "让人安心的不是技巧，而是「我随时可以停下来」这件事。",
      },
      {
        type: "p",
        text: "把这三条讲清楚，剩下的部分就可以放心交给笑声了。社区里所有话题分享也请遵守同样的原则：尊重、不越界、不强迫。",
      },
    ],
  },
  {
    id: "4",
    title: "从笑声到放松：挠痒体验里的情绪小知识",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20calm%20illustration%20of%20a%20person%20lying%20on%20a%20cream%20sofa%20with%20eyes%20closed%20and%20a%20gentle%20smile%2C%20warm%20blanket%20and%20small%20feather%20nearby%2C%20golden%20hour%20light%2C%20minimal%20flat%20editorial%20illustration%20in%20beige%20tones&width=800&height=500&seq=article-cover-04&orientation=landscape",
    excerpt:
      "大笑之后那种整个人松下来的感觉，并不是错觉。情绪和身体之间，本来就是来回拉扯的一对搭档。",
    author: "内容编辑 小满",
    date: "2026-10-05",
    tag: "情绪观察",
    tags: ["情绪", "放松", "治愈"],
    views: 11200,
    heat: 82,
    readMinutes: 6,
    content: [
      {
        type: "p",
        text: "很多人说，看一段挠痒视频或者和朋友玩几分钟之后，整个人会莫名轻松。这种松弛感从哪来？一部分答案藏在笑声之后的呼吸里。",
      },
      { type: "h2", text: "笑声是一种身体的运动" },
      {
        type: "p",
        text: "笑的时候，横膈膜和腹部肌肉会反复收缩，呼吸节奏被打断又重新建立。这种轻度的身体运动，会让人在结束后感到一种类似伸展过的舒畅。",
      },
      { type: "h2", text: "紧张与放松，需要一个开关" },
      {
        type: "p",
        text: "挠痒故意制造了一点点紧张：你猜不到下一秒会碰哪里。而当这份紧张在安全的环境里被反复唤起又释放，身体就完成了一次小小的「练习」——原来紧张之后是可以放松的。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Peaceful%20illustration%20of%20sunlight%20falling%20across%20a%20cream%20wall%20and%20a%20folded%20knit%20blanket%20on%20a%20wooden%20chair%2C%20warm%20dust%20motes%20in%20the%20air%2C%20minimal%20tranquil%20editorial%20style%20with%20beige%20palette&width=900&height=500&seq=article-inline-04&orientation=landscape",
        caption: "一点紧张、一点释放，最后落到安静上。",
      },
      { type: "h2", text: "为什么大家一起看更容易笑" },
      {
        type: "p",
        text: "在群体里，情绪会互相传染。看到别人大笑，自己的面部肌肉也会不自觉地模仿，这种「镜像」反应让笑声更容易扩散。所以社区里一起追更、一起讨论的氛围，本身就是内容的一部分。",
      },
      {
        type: "quote",
        text: "成年人的放松往往不需要仪式，只需要一小段可以安心分心的时光。",
      },
      {
        type: "p",
        text: "当然，放松方式因人而异。如果某类内容让你不适，关掉就好，不必勉强自己加入。轻松这件事，本来就没有标准答案。",
      },
    ],
  },
  {
    id: "5",
    title: "周末沙发计划：一场慢节奏的挠痒体验",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20weekend%20living%20room%20illustration%20with%20a%20beige%20sofa%2C%20warm%20knit%20socks%20on%20the%20floor%2C%20small%20side%20table%20with%20a%20mug%2C%20golden%20afternoon%20sun%20through%20sheer%20curtains%2C%20minimal%20warm%20flat%20illustration&width=800&height=500&seq=article-cover-05&orientation=landscape",
    excerpt:
      "不需要出门、不需要道具清单，一张沙发、一条毯子、一根羽毛，就足够撑起一个舒服的下午。",
    author: "闲日频道",
    date: "2026-10-03",
    tag: "生活方式",
    tags: ["生活方式", "放松", "周末"],
    views: 9800,
    heat: 79,
    readMinutes: 4,
    content: [
      {
        type: "p",
        text: "周末最奢侈的事情，大概是什么都不安排。这个下午我们建议你做三件事：把灯调暗一点、把脚放进毯子里、找一根羽毛。",
      },
      { type: "h2", text: "先把环境准备好" },
      {
        type: "p",
        text: "光线偏暖、声音安静、温度刚好，这三样比任何道具都重要。手机调成勿扰，给自己二十分钟完全不被打扰的时间。",
      },
      { type: "h2", text: "节奏比力度重要" },
      {
        type: "p",
        text: "从脚背开始，慢慢向下，速度越慢越好。不要急着制造反应，把注意力放在触感本身。很多人形容这种感觉像「有人轻轻帮自己按了暂停键」。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Warm%20still%20life%20illustration%20of%20a%20ceramic%20mug%20and%20a%20folded%20beige%20blanket%20beside%20a%20small%20feather%20on%20a%20cream%20sofa%20arm%2C%20afternoon%20light%2C%20minimal%20homely%20editorial%20flat%20style&width=900&height=500&seq=article-inline-05&orientation=landscape",
        caption: "一条毯子、一杯热饮，就够撑起一个下午。",
      },
      { type: "h2", text: "结束之后别急着起身" },
      {
        type: "p",
        text: "停下来之后再躺三五分钟，让呼吸慢慢恢复。这段时间往往是整个体验里最放松的部分，很多人会不知不觉睡着。",
      },
      {
        type: "quote",
        text: "好的放松不是做了很多事，而是终于可以什么都不做。",
      },
      {
        type: "p",
        text: "如果你也有自己的周末沙发计划，欢迎到社区里分享。所有体验都请以双方的舒适为前提。",
      },
    ],
  },
  {
    id: "6",
    title: "为什么脚心这么敏感？轻松读懂触觉小秘密",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20educational%20illustration%20of%20a%20pair%20of%20feet%20on%20a%20cream%20surface%20with%20abstract%20golden%20circular%20sensation%20patterns%20around%20the%20soles%2C%20warm%20beige%20palette%2C%20clean%20flat%20modern%20illustration&width=800&height=500&seq=article-cover-06&orientation=landscape",
    excerpt:
      "脚心几乎是全身最怕痒的地方之一。这并不奇怪——它承担着非常具体的工作，也布满了密集的感受器。",
    author: "科普小组",
    date: "2026-09-30",
    tag: "趣味科普",
    tags: ["科普", "触觉", "冷知识"],
    views: 14300,
    heat: 85,
    readMinutes: 5,
    content: [
      {
        type: "p",
        text: "如果给身体的怕痒程度排个名，脚心大概率能进前三。这件事和「娇气」无关，而是和它的工作内容有关。",
      },
      { type: "h2", text: "它需要非常灵敏" },
      {
        type: "p",
        text: "脚掌每天要应对各种地面，需要快速判断石头、尖刺、湿滑这些信息。为了完成这项工作，脚底的神经末梢密度相当高，轻微的触碰也能被清楚地捕捉到。",
      },
      { type: "h2", text: "它是「预料之外」最容易发生的地方" },
      {
        type: "p",
        text: "我们平时很少直视自己的脚心，对那个位置的视觉关注也很少。当触碰从那里传来，大脑缺少提前的预判，意外感就被放大，痒的感觉也随之变强。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Abstract%20warm%20illustration%20of%20concentric%20golden%20circles%20and%20soft%20curved%20lines%20on%20a%20cream%20background%20suggesting%20touch%20signals%2C%20minimal%20editorial%20graphic%20style%2C%20honey%20and%20beige%20tones&width=900&height=500&seq=article-inline-06&orientation=landscape",
        caption: "触觉信号越密集，轻微的触碰就越容易被放大。",
      },
      { type: "h2", text: "每个人都不一样" },
      {
        type: "p",
        text: "敏感度存在很大的个体差异，有人几乎没感觉，有人一碰就笑。这种差异和注意力、情绪状态、甚至当天的疲劳程度都有关系，所以完全不必拿自己和别人比较。",
      },
      {
        type: "quote",
        text: "身体的差异不是缺点，只是每个人出厂设置不同。",
      },
      {
        type: "p",
        text: "了解这些小知识，是为了更理解自己的反应，也更能尊重别人的感受。这一点在社区交流中尤其重要。",
      },
    ],
  },
  {
    id: "7",
    title: "记录一次安全又开心的互动体验",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20style%20illustration%20of%20a%20notebook%2C%20a%20feather%20and%20a%20cup%20of%20tea%20on%20a%20cream%20desk%20with%20soft%20sunlight%2C%20cozy%20journaling%20mood%2C%20minimal%20flat%20illustration%20in%20beige%20and%20muted%20yellow&width=800&height=500&seq=article-cover-07&orientation=landscape",
    excerpt:
      "一次舒服的体验，往往始于一次认真的沟通。这篇把我们在开始前、进行中和结束后的做法完整记录了下来。",
    author: "慢慢玩工作室",
    date: "2026-09-27",
    tag: "体验笔记",
    tags: ["体验", "沟通", "记录"],
    views: 8600,
    heat: 76,
    readMinutes: 6,
    content: [
      {
        type: "p",
        text: "我们习惯在每次拍摄前留出十分钟，什么都不做，只聊天。这十分钟里聊的内容，往往决定了整场体验是否舒服。",
      },
      { type: "h2", text: "开始前：把期待说清楚" },
      {
        type: "p",
        text: "我们会问彼此三个问题：今天想轻松一点还是想笑到不行？有没有哪里不想被碰？大概玩多久？答案不需要很精确，但必须说出来。",
      },
      { type: "h2", text: "进行中：随时观察" },
      {
        type: "p",
        text: "笑声很大不代表享受，安静也不代表不适。真正可靠的是提前约定的信号，以及随时愿意停下来的态度。节奏慢一点，永远更容易调整。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Soft%20illustration%20of%20two%20hands%20gently%20holding%20a%20small%20notebook%20and%20pen%20on%20a%20cream%20linen%20surface%20with%20warm%20light%2C%20minimal%20calm%20editorial%20flat%20style%20in%20beige%20tones&width=900&height=500&seq=article-inline-07&orientation=landscape",
        caption: "把感受记下来，下一次会更清楚自己要什么。",
      },
      { type: "h2", text: "结束后：聊两句" },
      {
        type: "p",
        text: "结束后我们一定会聊几句：哪一段最舒服、哪一段想跳过、下次想试什么。不需要长篇大论，两三句话就能让下一次更好。",
      },
      {
        type: "quote",
        text: "让体验变好的从来不是更厉害的道具，而是更诚实的对话。",
      },
      {
        type: "p",
        text: "这份记录并不特别，只是把大家平时会做的事认真做了一遍。如果你也想开始，不妨从这十分钟的聊天开始。",
      },
    ],
  },
  {
    id: "8",
    title: "新手也能上手：轻松挠痒体验入门指南",
    cover:
      "https://readdy.ai/api/search-image?query=Friendly%20beginner%20guide%20illustration%20with%20three%20simple%20step%20cards%2C%20a%20feather%2C%20a%20soft%20brush%20and%20a%20blanket%20on%20a%20cream%20table%2C%20warm%20golden%20light%2C%20minimal%20flat%20vector%20editorial%20style&width=800&height=500&seq=article-cover-08&orientation=landscape",
    excerpt:
      "如果你对这个主题好奇，却不知道从哪里开始，这份入门指南把需要准备的东西压缩到了最少的三件事。",
    author: "社区管理员 阿栗",
    date: "2026-09-24",
    tag: "新手指南",
    tags: ["新手", "指南", "入门"],
    views: 20400,
    heat: 93,
    readMinutes: 7,
    content: [
      {
        type: "p",
        text: "很多新朋友的第一句话都是：我该从哪里开始？答案其实比想象中简单——从一次轻松的聊天开始，而不是从一堆道具开始。",
      },
      { type: "h2", text: "第一件：找到愿意一起玩的人" },
      {
        type: "p",
        text: "这听起来像是废话，但确实是关键。让对方知道这只是个轻松的小游戏，随时可以停，不需要勉强。愿意的人自然会愿意，不愿意也不必劝。",
      },
      { type: "h2", text: "第二件：选一个温和的道具" },
      {
        type: "p",
        text: "羽毛或丝巾是最稳妥的选择。它们触感轻、可控性好，不容易造成不适。第一次不要追求强烈反应，把重点放在「舒服」上。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=Gentle%20illustration%20of%20a%20white%20feather%20and%20a%20folded%20silk%20scarf%20on%20a%20cream%20cushion%20with%20warm%20sunlight%20and%20soft%20shadow%2C%20minimal%20calm%20composition%2C%20beige%20palette%2C%20flat%20editorial%20style&width=900&height=500&seq=article-inline-08&orientation=landscape",
        caption: "羽毛和丝巾，是最适合新手的两件道具。",
      },
      { type: "h2", text: "第三件：留出可以停下来的时间" },
      {
        type: "p",
        text: "不要把时间排得太满。二十到三十分钟刚刚好，中间随时可以休息。结束之后留几分钟安静待着，让情绪慢慢落回去。",
      },
      {
        type: "quote",
        text: "入门不需要技巧，只需要一点好奇和很多尊重。",
      },
      {
        type: "p",
        text: "掌握这三件事，你已经可以开始了。剩下的经验，都会在一次次轻松的尝试里慢慢长出来。",
      },
    ],
  },
];